import useTimeZoneClock from "hooks/useTimeZoneClock";
import { getBackgroundStyle } from "components/common/TableColor";
import moment from "moment";
import React from "react";

const TranslationViewTable = React.memo(({ item }) => {
  const timeZone = useTimeZoneClock(item?.datetime);
  const formattedDate = moment(timeZone).format("MMMM DD YYYY");
  const formattedTime = moment(timeZone).format("hh:mm A");

  const InfoRow = ({ label, value, toLowerCase = "" }) => (
    <div className="row_detail_tab">
      <div className="label_view">
        <strong>{label}</strong>
      </div>
      <div className={`detail_view ${toLowerCase}`}>{value || "N/A"}</div>
    </div>
  );
  const rowDash1Style = {
    display: "flex",
    alignItems: "normal",
    width: "100%",
    gap: "1rem",
  };
  const rowDash2Style = {
    display: "block",
    alignItems: "normal",
    width: "100%",
    gap: "1rem",
  };
  const marginTopZero = {
    marginTop: 0,
  };
  return (
    //    Done
    <div className="Table_data_show Table_data_show1 p-0 overflow-auto">
      <div className="row_dash_1" style={rowDash1Style}>
        <div className="card_table" style={marginTopZero}>
          <div className="Table_data_show Table_data_show1 pt-0">
            <table class="bg-primary-secondary table">
              <tbody>
                <tr>
                  <td class="bg-primary-secondary" style={{ width: "40%" }}>
                    Request ID:
                  </td>
                  <td class="bg-primary-secondary">#{item?.transid}</td>
                </tr>
                <tr>
                  <td class="bg-primary-secondary" style={{ width: "40%" }}>
                    Requested At:
                  </td>
                  <td class="bg-primary-secondary">
                    {item?.created_at &&
                      moment(item?.created_at).format("MMM D, YYYY HH:mm:ss")}
                  </td>
                </tr>
                <tr>
                  <td class="bg-primary-secondary" style={{ width: "40%" }}>
                    Last Quote Sent:
                  </td>
                  <td class="bg-primary-secondary">
                    Version: {item?.quotations && item?.quotations[0]?.version}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="Table_data_show Table_data_show1 pt-0 ">
            <table class="bg-primary-secondary table">
              <tbody>
                <tr>
                  <td class="bg-primary-secondary" style={{ width: "40%" }}>
                    Due Date:
                  </td>
                  <td class="bg-primary-secondary">
                    {item?.translation_details?.due_date
                      ? moment(item?.translation_details?.due_date).format(
                          "MMM D, YYYY"
                        )
                      : "N/A"}
                  </td>
                </tr>
                <tr>
                  <td class="bg-primary-secondary" style={{ width: "40%" }}>
                    Completed Date:
                  </td>
                  <td class="bg-primary-secondary">
                    {(item?.status == "Completed" &&
                      moment(item?.updated_at, "YYYY-MM-DD HH:mm:ss").format(
                        "MMM D, YYYY HH:mm:ss"
                      )) ||
                      "N/A"}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div className="Table_data_show Table_data_show1 pt-0 ">
            <table class="bg-primary-secondary table">
              <tbody>
                <tr>
                  <td class="bg-primary-secondary" style={{ width: "40%" }}>
                    Source Language:
                  </td>
                  <td class="bg-primary-secondary">
                    {item.language?.name || "N/A"}
                  </td>
                </tr>
                <tr>
                  <td className="bg-primary-secondary" style={{ width: "40%" }}>
                    Target Language:
                  </td>
                  <td className="bg-primary-secondary">
                    {Array.isArray(item.translation_target_languages) &&
                    item.translation_target_languages.length > 0
                      ? item.translation_target_languages
                          .map((tl) => tl.language?.name)
                          .filter(Boolean)
                          .join(", ")
                      : "N/A"}
                  </td>
                </tr>
                <tr>
                  <td class="bg-primary-secondary" style={{ width: "40%" }}>
                    Notes:
                  </td>
                  <td class="bg-primary-secondary">
                    {item?.translation_details?.comment || "N/A"}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div className="card_table" style={marginTopZero}>
          <div className="Table_data_show Table_data_show1 pt-0">
            <table class="bg-primary-secondary table">
              <tbody>
                <tr>
                  <td className="bg-primary-secondary" style={{ width: "40%" }}>
                    Requestor Name:
                  </td>
                  <td className="bg-primary-secondary">
                    {item?.requester_name}
                  </td>
                </tr>
                <tr>
                  <td className="bg-primary-secondary" style={{ width: "40%" }}>
                    Requester Email:
                  </td>
                  <td className="bg-primary-secondary">
                    {item?.translation_details?.requester_email}
                  </td>
                </tr>
                <tr>
                  <td className="bg-primary-secondary" style={{ width: "40%" }}>
                    Requester Phone:
                  </td>
                  <td className="bg-primary-secondary">
                    {item?.translation_details?.requester_phone}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="Table_data_show Table_data_show1 pt-0 ">
            <table class="bg-primary-secondary table">
              <tbody>
                <tr>
                  <td class="bg-primary-secondary" style={{ width: "40%" }}>
                    Formatting Required:
                  </td>
                  <td class="bg-primary-secondary">
                    {item.translation_details?.formatting ? "Yes" : "No"}
                  </td>
                </tr>
                <tr>
                  <td class="bg-primary-secondary" style={{ width: "40%" }}>
                    Rush/expedited Required:
                  </td>
                  <td class="bg-primary-secondary">
                    {item.translation_details?.rush ? "Yes" : "No"}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="Table_data_show Table_data_show1 pt-0 ">
            <table class="bg-primary-secondary table">
              <tbody>
                <tr>
                  <td class="bg-primary-secondary" style={{ width: "40%" }}>
                    Total Words Count:
                  </td>
                  <td class="bg-primary-secondary">
                    {item?.total_words_count}
                  </td>
                </tr>
                <tr>
                  <td class="bg-primary-secondary" style={{ width: "40%" }}>
                    Total Amount:
                  </td>
                  {console.log(item, "item in view table")}
                  <td class="bg-primary-secondary">$ {item?.total_amount}</td>
                </tr>
                <tr>
                  <td class="bg-primary-secondary" style={{ width: "40%" }}>
                    Translator:
                  </td>
                  <td class="bg-primary-secondary">
                    {item?.interpreter?.user?.name || "N/A"}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      {(item?.status === "Cancelled" ||
        item?.status === "Client Cancelled" ||
        item?.status === "Translator Declined") && (
        <div className="row_dash_1" style={rowDash1Style}>
          <div className="card_table" style={marginTopZero}>
            <div className="Table_data_show Table_data_show1 pt-0 ">
              <table class="bg-primary-secondary table">
                <tbody>
                  {(item?.status === "Cancelled" ||
                    item?.status === "Client Cancelled") && (
                    <>
                      <tr>
                        <td
                          class="bg-primary-secondary"
                          style={{ width: "20%" }}
                        >
                          Cancelled By:
                        </td>
                        <td class="bg-primary-secondary">
                          {item.translation_details?.cancelled_by?.name ||
                            "N/A"}
                        </td>
                        <td
                          class="bg-primary-secondary"
                          style={{ width: "20%" }}
                        >
                          Cancelled At:
                        </td>
                        <td class="bg-primary-secondary">
                          {moment(
                            item?.translation_details?.cancelled_at,
                            "YYYY-MM-DD HH:mm:ss"
                          ).format("MMM D, YYYY HH:mm:ss") || "N/A"}
                        </td>
                      </tr>
                      <tr>
                        <td
                          colSpan={1}
                          className="bg-primary-secondary"
                          style={{ width: "20%" }}
                        >
                          Cancellation Reason:
                        </td>
                        <td colSpan={3} className="bg-primary-secondary">
                          {item?.translation_details?.cancel_reason}
                        </td>
                      </tr>
                    </>
                  )}
                  {item?.status === "Translator Declined" && (
                    <tr>
                      <td
                        colSpan={1}
                        className="bg-primary-secondary"
                        style={{ width: "20%" }}
                      >
                        Decline Reason:
                      </td>
                      <td colSpan={3} className="bg-primary-secondary">
                        {item?.translation_details?.translation_decline_reason}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}
    </div>
  );
});

export default TranslationViewTable;
